import { RG_TYPE } from '../../types/rg-type.js';

const DefaultColumn = {
    type: RG_TYPE.Column,
    size: [0.1, 3, 0.1],
    anchor: [0.5, 0, 0.5],
    name: 'column',
    color: '#8E3939',
    children: []
};

export { DefaultColumn };
//# sourceMappingURL=default-column.js.map
